<template>
  <div class="container container--fluid">
     <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ Reset User Password</span>
    </v-row><br />
    <v-app id="inspire">
      
    
      <template v-if="load==true">
        <v-data-table
          :headers="headers"
          :items="userlist"
          sort-by="roletype.name"
          class="elevation-1 nowrap"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Reset User Password</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            <span style="width: 20px"> </span>
              <v-dialog v-model="dialog" max-width="500px">
              <!--  <template v-slot:activator="{ on }">
                  <v-btn color="indigo darken-4" dark class="mb-2" v-on="on" >New User</v-btn>
                </template>
                -->
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row dense>
                        <v-col cols="12" >
                          <v-text-field dense 
                          v-model.trim="editedItem.username" 
                          label="Username"
                          :suffix=uid_domain
                           persistent-hint
                          :disabled="editedIndex != -1"
                          :hint="editedIndex==-1?'':'noneditable'"
                          :filled="editedIndex==-1?false:true"
                         :error="errorMsg.username?true:false"
                         :error-messages="errorMsg.username?'Required':''"
                          ></v-text-field>
                          <span v-if="editedIndex==-1">{{editedItem.username}}{{uid_domain}}</span>
                        </v-col>
                        <v-col cols="1" >
                          <v-hidden v-model="editedItem.id" label="id"></v-hidden>
                        </v-col>
                      </v-row>
                      
                      <v-row>
                        <v-col cols="6" sm="3" md="2">
                          <v-checkbox v-model="editedItem.isloginblocked" color="success" label="isBlocked?"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="primary darken-1"  @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.isloginblocked="{ item }">
              <span v-if="item.isloginblocked">
                <v-icon  class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
              </span>
              <span v-else>
                <v-icon  class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
              </span>
          </template>
          <template v-slot:item.action="{ item }">
            <div>
            <v-btn color="primary darken-1"  @click="save(item)">RESET PASSWORD</v-btn>
          <!-- <v-avatar  size="25" class="edit-avatar">
           
            <v-icon  class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
           </v-avatar>
           -->
            </div>
          </template>
          
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </template>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    errorMsg:{ username:false},
    search:'',
    snackbar_msg: "",
    color: "",
    snackbar: false,
    uid_domain:'',
    load: false,
    dialog: false,
    userlist: {},
    headers: [
      { text: "Username", value: "username" },
      { text: "Actions", value: "action", sortable: false }
    ],
    
    editedIndex: -1,
    editedItem: {
      username: "",
      id: "",
      isloginblocked:false,
    },
    defaultItem: {
      username: "",
      id: "",
      isloginblocked:false,
    }
    
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  mounted() {
    axios
      .post("/AdminMaster/resetUserPassword")
      .then(res => {
        if (res.data.msg == "200") {
          this.userlist = res.data.userlist;
          console.log(this.userlist);
          this.uid_domain = res.data.uid_domain;
          this.load = true;
        } else {
        }
      })
      .catch(error => {
        window.console.log(error);
      });
  },

  methods: {
     initializeErrorMsgFalse(){
      this.errorMsg.username=false;
    },
    
     showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      
      this.editedIndex = this.userlist.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.userlist.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.userlist.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save(item) {
      this.initializeErrorMsgFalse();
      this.editedIndex = this.userlist.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if(confirm("Are you sure you want to reset password of "+this.editedItem.username+" ?")){
        axios
          .post("/AdminMaster/resetAdminUserPassword", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
              Object.assign(this.userlist[this.editedIndex], this.editedItem);
               this.showSnackbar(
                  "#4caf50",
                  "User Password Reset to username Successfully..."
                ); // show snackbar on success
            }
          })
          .catch(error => {
            window.console.log(error);
          });

          this.close();
      }
    },

    isValidated(){
      if(this.editedItem.username)
       { 
          
          return true; 
       }
      else{
            if(!this.editedItem.username)
            {
              this.errorMsg.username=true
            }
        return false;
      }  
     } // .....end of isValidated()
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>